package com.zaurh.mapquizwebsite.presentation.screen.main.right

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.zaurh.mapquizwebsite.presentation.screen.home.MainUIState
import com.zaurh.mapquizwebsite.utils.getOutfitFont
import mapquizwebsite.shared.generated.resources.Res
import mapquizwebsite.shared.generated.resources.ic_cash
import mapquizwebsite.shared.generated.resources.ic_gold
import mapquizwebsite.shared.generated.resources.mapquiz_cover_dark
import org.jetbrains.compose.resources.painterResource

@Composable
fun MainScreenRight(
    modifier: Modifier = Modifier,
    uiState: MainUIState,
    onSignInClicked: () -> Unit,
    onLogOutClicked: () -> Unit
) {
    val userData = uiState.userData
    Surface(
        modifier = modifier.fillMaxSize()
    ) {
        Column(
            modifier = Modifier.fillMaxSize().padding(top = 12.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            if (userData != null) {
                Image(
                    painter = painterResource(Res.drawable.mapquiz_cover_dark),
                    contentDescription = null,
                    modifier = Modifier.clip(CircleShape).size(120.dp).clickable {
                        onLogOutClicked()
                    },
                    contentScale = ContentScale.Crop
                )
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = userData.username,
                    fontFamily = getOutfitFont(),
                    fontWeight = FontWeight.SemiBold,
                    fontSize = 18.sp
                )
                Spacer(modifier = Modifier.height(12.dp))
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Image(
                        painter = painterResource(Res.drawable.ic_gold),
                        contentDescription = null,
                        modifier = Modifier.size(32.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(text = userData.gold.toString(), fontFamily = getOutfitFont())
                    Spacer(modifier = Modifier.width(16.dp))
                    Image(
                        painter = painterResource(Res.drawable.ic_cash),
                        contentDescription = null,
                        modifier = Modifier.size(32.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(text = userData.cash.toString(), fontFamily = getOutfitFont())
                }

            } else {
                Button(
                    modifier = Modifier.fillMaxWidth(0.8f)
                        .pointerHoverIcon(icon = PointerIcon.Hand),
                    shape = RoundedCornerShape(10.dp),
                    onClick = {
                        onSignInClicked()
                    }) {
                    Text(text = "Sign in", fontFamily = getOutfitFont(), fontSize = 16.sp)
                }
            }
        }
    }
}